/**
 * Used on a discussion creation form
 *  * Determines if it should initiate bootstrap collapse transition on render
 *  * Allows an element to be focused on after form is shown
 *
 * Accepts values:
 *  * (optional) collapse-on-show - whether form should be transitioned to closed upon render
 */
import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";

export default class extends Controller {
  static values = {
    collapseOnShow: { type: Boolean, default: false },
  };

  static get targets() {
    return ["focusElement"];
  }

  connect() {
    if (this.hasFocusElementTarget) {
      this.element.addEventListener("shown.bs.collapse", () => {
        this.focus();
      });
    }

    if (this.collapseOnShowValue) {
      bootstrap.Collapse.getOrCreateInstance(this.element).hide();
    }
  }

  focus() {
    this.focusElementTarget.focus();
  }
}
